import React, { useEffect, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import { Carousel } from 'react-responsive-carousel';

import styles from "./Brands.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducer';

export interface IBrand {
    brandId: number,
    brandName: string,
    imageURL: string,
    brandCode: string,
    displayOrder: number
}
interface PropsType {
    brands: IBrand[],
    subHeading: string | null,
    mainHeading: string | null,
    content: string,
    showButton: boolean
}
var slideNo = 1;

export default function Brands(props: PropsType) {
    const dispatch = useDispatch();
    const responsive = useSelector((state: RootState) => state.responsive);
    const [showMobBrands, setShowMobBrands] = useState<IBrand[]>(props.brands.slice(0, 4));
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const prodsPerSlide = 4;
    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])

    function dotValue(maxLength: number) {

        var val = ((slideNo - 1) * prodsPerSlide) + showMobBrands.length;
        if (val < 10) {
            return '0' + val;
        }
        if (val > maxLength) {
            val = maxLength
        }
        return val;
    }
    function plusSlides(n: number) {
        showProductList(slideNo += n);
    }
    function showProductList(n: number) {
        if (n < 1) {
            slideNo = 1;
        }
        if (n * prodsPerSlide > props.brands.length) {
            slideNo = Math.floor(props.brands.length / prodsPerSlide) + 1;
        }
        var noOfSlides = slideNo * prodsPerSlide;
        var newArray = props.brands.slice((noOfSlides) - prodsPerSlide, noOfSlides);
        setShowMobBrands(newArray);

        if ((noOfSlides) > props.brands.length && (((slideNo - 1) * prodsPerSlide) - 1) < props.brands.length) {
            noOfSlides = props.brands.length;
            // slideNo = slideNo - 1;
            var newArray = props.brands.slice((slideNo - 1) * prodsPerSlide, noOfSlides);
            setShowMobBrands(newArray);
        }
    }
    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <Row>
                    <Col lg="5" md="5" xs="12" className={`${styles.selectedDetailSection}`}>
                        <Row>
                            <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeading}`} hidden>
                                <span>{props.subHeading}</span>
                            </Col>
                            <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                                <span>{props.mainHeading}</span>
                            </Col>
                            <Col lg="12" md="12" xs="12" style={{ paddingBottom: "2rem" }}>
                                <p>{props.content}</p>
                            </Col>
                            {props.showButton ?
                                <Col lg="12" md="12" xs="12">
                                    <div>
                                        <Button onClick={() => {
                                            window.location.href = "/products/all";
                                        }}
                                            className="jkoa-blue-btn" style={{ padding: "0.3rem 1rem" }}>  Explore
                                        </Button>
                                    </div>
                                </Col>
                                : null}
                        </Row>
                    </Col>
                    {!isWeb ?
                        <Col md="12" className={`${styles.brandsSectionContainerMobile}`}>
                            <Row>
                                {showMobBrands.map((item, index) => {
                                    return (
                                        <Col key={index} style={{ padding: "4px 10px" }} lg="6" md="6" xs="6" className={`${styles.fade} d-flex justify-content-center m-0`}>
                                            <div key={item.brandId} className={`${styles.brandSectionMob}`} >
                                                <img src={item.imageURL} alt={item.brandName + `-img`} className="img-fluid"
                                                    onClick={() => {
                                                        window.location.href = "/products/" + item.brandName.replace(/[/ ]/g, "_").toLowerCase();
                                                    }} />
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                            <Row style={{ paddingTop: "20px" }}>
                                <Col lg="2" md="2" xs="2" className={`${styles.progressBarSelected}`}>
                                    <p>{dotValue(props.brands.length)}/{props.brands.length}</p>
                                </Col>
                                <Col className={`${styles.arrowkeys}`}>
                                    <i className={` fas fa-long-arrow-alt-left fa-3x ${styles.prev}`} onClick={() => plusSlides(-1)} />
                                    <i className={` fas fa-long-arrow-alt-right fa-3x ${styles.next}`} onClick={() => plusSlides(1)} />
                                </Col>
                            </Row>

                            {/* <Carousel
                                autoPlay={false}
                                showArrows={false}
                                swipeable={true}
                                showStatus={false}
                                centerMode={true}
                                showIndicators={false}
                                showThumbs={false}
                            >
                                {props.brands.map((item) => {
                                    return (
                                        <div key={item.brandId} className="d-flex justify-content-center">
                                            <div className={`${styles.brandSectionMobile}`} onClick={() => { window.location.href = "/ProductListing?lt=" + productListingType.brand + "&id=" + item.brandId }}>
                                                <img src={item.imageURL} alt={item.brandName + `-img`} className="img-fluid" />
                                            </div>
                                        </div>
                                    );
                                })}
                            </Carousel> */}
                        </Col>
                        :
                        <Col className={`${styles.brandsSection}`}>
                            <Row>
                                {props.brands.map((item, index) => {
                                    return (
                                        <Col key={index} style={{ padding: "0" }} lg="3" md="3" xs="12" className="d-flex justify-content-center m-0">
                                            <div key={item.brandId} className={`${styles.brandSection}`} onClick={() => {
                                                window.location.href = "/products/" + item.brandName.replace(/[/ ]/g, "_").toLowerCase();
                                            }}>
                                                <img src={item.imageURL} alt={item.brandName + `-img`} className="img-fluid" />
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Col>
                    }


                </Row>
            </div>
        </React.Fragment>
    )
}